export const LEAD_ACTION_TOOLTIPS = {
  treatAndRegister:
    "מסמן את הליד בטיפול שלך ופותח את תהליך בחירת המשימות ורישום המתנדב",
  continueRegister: "ממשיך את תהליך הרישום לליד שכבר בטיפול שלך",
  treatDisabledOther: (managerName: string) =>
    `הליד בטיפול של ${managerName}. לא ניתן לרשום במקביל עד שישוחרר הטיפול`,
  treatDisabledNoConsent:
    "לליד אין הסכמה ליצירת קשר - לא ניתן לרשום מתנדב או לשלוח התראות",
  communication:
    "פותח תיעוד שיחה עם המתנדב. דורש פרופיל קיים במערכת והסכמה ליצירת קשר",
  communicationDisabled: "דורש הסכמה ליצירת קשר מהליד",
  decline:
    "מסמן את הליד כלא רלוונטי לטיפול. ניתן למצוא אותו אחר כך בטאב 'לא לטפל'",
  moreActions: "תיעוד שיחה, סימון כלא לטפל ועוד",
  noConsentWarning: "לליד אין הסכמה ליצירת קשר",
  claimHandling:
    "מסמן שהליד בטיפול שלך. מנהלים אחרים יראו זאת ולא יוכלו לרשום במקביל",
  releaseHandling:
    "משחרר את הטיפול בליד ומאפשר למנהל אחר לקחת אותו",
  copyLoginLink:
    "מעתיק ללוח את קישור הכניסה לקמפיין - לשליחה למתנדבים חדשים",
  exportCsv: "מייצא את הלידים המוצגים כרגע (לפי הסינון הפעיל) לקובץ Excel",
  statsPending: "לידים חדשים שממתינים לטיפול ראשון",
  statsMine: "לידים שסימנת כרגע כ'בטיפול שלי'",
  statsProcessed: "לידים שכבר נרשמו למשימות או סומנו כטופלו",
  statsAll: "כל הלידים במערכת, ללא קשר לסטטוס",
  statsDeclined: "לידים שסומנו במפורש כלא לטפל",
  statsToday: "כמה לידים נכנסו היום - לניטור בלבד, לא מסנן את הטבלה",
  browseMatched:
    "מציג משימות לפי צוות וזמינות. קטגוריה וסוג נוכחות משפיעים על דירוג ההתאמה",
  browseAll: "מאפשר לחפש ולהוסיף משימות מכל המשימות הפתוחות",
  filterByLeadAttendance:
    "מציג את כל ההתאמות לפי צוות וזמינות, כולל משימות קבוצה לליד יחיד (ולהפך) כהתאמה חלקית",
  filterGroup: "מציג רק משימות לקבוצות",
  filterIndividual: "מציג רק משימות ליחידים",
  filterAllTypes: "מציג משימות מכל סוגי הנוכחות",
  selectAllMatches: "בוחר את כל המשימות המתאימות שעדיין לא נרשמו",
  clearMatches: "מסיר את הבחירה ממשימות הרשימה המתאימה",
  addOpportunity:
    "פותח חלון לבחירת משימה בודדת מתוך כל המשימות הפתוחות",
  fullTable:
    "פותח טבלת משימות מלאה עם סינונים, לבחירה מרובה והתאמות לליד",
  pickerBackToLead:
    "חוזר לתהליך רישום הליד בלי לשמור את הבחירות שעשית בטבלה זו (הבחירות הקודמות נשמרות)",
  wizardNextMissions: "ממשיך להזנת פרטי המתנדב. דורש לפחות משימה אחת נבחרת",
  wizardNextVolunteer: "ממשיך למסך אישור לפני הרישום הסופי",
  wizardBack: "חוזר לשלב הקודם בלי לאבד את הנתונים שהוזנו",
  wizardSubmit:
    "מאמת את הנתונים, רושם את המתנדב למשימות שנבחרו ומעדכן את סטטוס הליד",
  wizardCancel: "סוגר את התהליך. הטיפול בליד נשאר אצלך עד שתשחרר אותו",
  wizardDone: "סוגר את החלון לאחר רישום מוצלח",
  sendNotification:
    "שולח למתנדב התראה על הרישום למשימות (דורש הסכמה ליצירת קשר)",
} as const;

export function treatButtonTooltip(options: {
  isMine: boolean;
  isOther: boolean;
  hasConsent: boolean;
  managerName?: string | null;
}): string {
  if (!options.hasConsent) return LEAD_ACTION_TOOLTIPS.treatDisabledNoConsent;
  if (options.isOther) {
    return LEAD_ACTION_TOOLTIPS.treatDisabledOther(
      options.managerName ?? "מנהל אחר",
    );
  }
  if (options.isMine) return LEAD_ACTION_TOOLTIPS.continueRegister;
  return LEAD_ACTION_TOOLTIPS.treatAndRegister;
}
